export const environment = {
    production: false,
    name: 'dev',
    sk: 'acegikmoqsuwy13579',
    loginFeature: true,
    folderName: '',
    apiUrl: 'https://genai-eus-pulseagent-dev-as01.azurewebsites.net/api/',
    msalConfig: {
        auth: { 
          clientId: 'b0c99442-8a01-4901-871b-db93b863e754',
          authority: 'https://login.microsoftonline.com/de08c407-19b9-427d-9fe8-edf254300ca7',
          redirectUri: 'https://ioapulse-agentuat.cognizantagentics.com/'
        }
    },
    apiConfig: {
      scopes: ['openid', 'profile', 'email'],
      uri:'Enter URI',
    },
    fridayFlowOnly: false,
    klApi: true,
    klApiUrl: 'https://genai-eus-ebuintellect-poc-as03.azurewebsites.net/api/'
};
  